export default "/images/87636e2f9bf5b71a94c892974c9ca23c.avif";